<template>
  <transition name="modal">
    <div id="cu-nopol-truck" class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-2 col-md-3 col-lg-4"></div>
          <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4">
            <div class="modal-container" @click.stop>
              <div
                class="transporter-modal-header"
                style="display: flex; justify-content: space-between"
              >
                <h2 class="transporter-title">
                  {{ isNew ? "Tambah" : "Ubah" }} Nopol
                </h2>
                <div class="modal-close" @click="$emit('closeModal')">
                  <i class="fal fa-times fa-2x"></i>
                </div>
              </div>

              <div class="modal-body">
                <div class="row transporter-input-row-group">
                  <div class="col">
                    <label class="transporter-label">Nama Driver</label>
                  </div>
                  <div class="col">
                    <input
                      type="text"
                      class="transporter-input"
                      placeholder="Ketik Nama Driver"
                      v-model="form.fullname"
                    />
                  </div>
                </div>

                <div class="row transporter-input-row-group">
                  <div class="col">
                    <label class="transporter-label">Nomor Polisi</label>
                  </div>
                  <div class="col">
                    <input
                      type="text"
                      class="transporter-input"
                      placeholder="Ketik Nomor Polisi"
                      v-model="form.nopol"
                    />
                  </div>
                </div>

                <div
                  class="row transporter-input-row-group"
                  :style="{
                    'margin-bottom': kode_ekspedisi_multiselect_open
                      ? '110px'
                      : '10px',
                  }"
                >
                  <div class="col">
                    <label class="transporter-label">Kode Ekspedisi</label>
                  </div>
                  <div class="col">
                    <MultiSelect
                      v-model="form.ekspedisi"
                      :options="ekspedisiOptions"
                      :multiple="false"
                      :maxHeight="100"
                      selectLabel=""
                      deselectLabel=""
                      selectedLabel=""
                      @open="kode_ekspedisi_multiselect_open = true"
                      @close="kode_ekspedisi_multiselect_open = false"
                      class="transporter-multiselect no-caret"
                      placeholder="Select One"
                    />
                  </div>
                </div>

                <div class="row transporter-input-row-group">
                  <div class="col">
                    <label class="transporter-label"
                      >{{ isNew ? "" : "Reset " }} Password</label
                    >
                  </div>
                  <div class="col">
                    <input
                      type="password"
                      class="transporter-input"
                      :placeholder="isNew ? 'Ketik Password' : 'Reset Password'"
                      v-model="form.password"
                    />
                  </div>
                </div>

                <div class="row" style="margin-top: 60px">
                  <div class="col">
                    <button
                      class="btn transporter-button-outline"
                      @click="$emit('closeModal')"
                    >
                      Batal
                    </button>
                  </div>
                  <div class="col">
                    <button
                      class="btn transporter-button"
                      @click="submitForm()"
                    >
                      {{ isNew ? "Tambah": "Edit" }}
                    </button>
                  </div>
                </div>

                <!-- <h2 class="title">{{ isNew ? 'Tambah' : 'Ubah' }} Nopol</h2>
                                <p class="sub--title">* is a required field</p>
                                <form>
                                    <div class="row row-space">
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Full Name<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.fullname"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Full Name"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Nomor Polisi<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.nopol"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Nomor Polisi"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6 offset-md-3">
                                            <div class="input-group">
                                                <label class="label">Ekspedisi<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.ekspedisi"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Ekspedisi"
                                                >
                                                <MultiSelect
                                                    v-model="form.ekspedisi"
                                                    :options="['5637144607', '5637144609', '5637144611', '5637163326', 'ABH -', 'GLB', 'GLB -', 'ICN -', 'INT -', 'JST -', 'KOPKAR -', 'PJL -', 'SWI -']"
                                                    :multiple="false"
                                                    class="transporter-multiselect no-caret"
                                                    placeholder="Select Ekspedisi"
                                                />
                                            </div>
                                        </div>
                                        <template v-if="isNew">
                                            <div class="col-md-6">
                                                <div class="input-group">
                                                    <label class="label">Password<span style="color: red;">*</span></label>
                                                    <input
                                                        v-model="form.password"
                                                        type="password"
                                                        class="input--style-4"
                                                        placeholder="Type Password"
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="input-group">
                                                    <label class="label">Re-type Password<span style="color: red;">*</span></label>
                                                    <input
                                                        v-model="retype_password"
                                                        type="password"
                                                        class="input--style-4"
                                                        placeholder="Type Retype Password"
                                                    >
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="row row-space outerBoxPass" v-if="!isNew">
                                      <div class="col innerBoxPass paddingInnerInnerBox whiteBg">
                                        <div class="row" @click="collapsedPass = !collapsedPass">
                                          <div class="col-6 left">
                                            <p class="subPartTitle">Reset Password</p>
                                          </div>
                                          <div class="col-6 right">
                                            <button type="button" class="btn btn-link collapseButton" v-if="collapsedPass">+</button>
                                            <button type="button" class="btn btn-link collapseButton" v-else>-</button>
                                          </div>
                                        </div>
                                        <div class="row" v-if="!collapsedPass">
                                          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="input-group">
                                              <label class="label">Password</label>
                                              <input class="input--style-4" type="password" name="password" v-model="form.password" placeholder="Type Password">
                                            </div>
                                          </div>
                                          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="input-group">
                                              <label class="label">Re-type Password</label>
                                              <input class="input--style-4" type="password" name="retype_password" v-model="retype_password" placeholder="Type Retype Password">
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                        <div class="col mt-5" style="text-align: center">
                                            <button type="button" class="btn btn-outline-danger" style="font-size:140%"
                                                @click="$emit('closeModal')">Cancel</button>
                                            <button type="button" class="btn btn-primary ml-5" style="font-size:150%"
                                                @click="submitForm()">{{ isNew ? 'Create' : 'Edit' }}</button>
                                        </div>
                                    </div>
                                </form> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-2 col-md-3 col-lg-4"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import MultiSelect from "vue-multiselect";
import axios from "axios";

export default {
  data() {
    return {
      dataReady: false,
      mobile: this.isMobile(),
      isNew: true,
      options: {
        gudang: [],
      },
      isLoading: false,
      form: {
        fullname: "",
        nopol: "",
        ekspedisi: null, // Selected ekspedisi
        password: ""
      },
      ekspedisiOptions: [], // Array to store options
      retype_password: "",

      kode_ekspedisi_multiselect_open: false,

      collapsedPass: true,
    };
  },
  props: [
    "data", //data used for edit mode
    "api_new", //api url used for new
    "api_edit", //api url used for edit
  ],
  components: {
    MultiSelect,
  },
  async mounted() {
    if (this.data) await this.convertEdit();

    axios.get("/api/master/gudang").then((response) => {
      this.options.gudang = response.data.data.map((val) => val.dealer_code);
    });

    /// Make an API request to fetch the data
    axios
      .get("/api/settings/get-ekspedisi")
      .then((response) => {
        // Extract 'ekspedisi' values and store them in the 'ekspedisiOptions' array
        this.ekspedisiOptions = response.data.data.map(
          (item) => item.ekspedisi
        );
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  },
  watch: {
    "form.karesidenan"() {
      this.options.city = this.$store.getters.getCityBySingleId(
        this.form.karesidenan
      );
      this.form.city = "";
    },
  },
  methods: {
    convertEdit() {
      this.isNew = false;

      this.form.id = this.data.id;
      this.form.fullname = this.data.fullname;
      this.form.nopol = this.data.nopol;
      this.form.ekspedisi = this.data.ekspedisi;
    },
    notNullObject(obj) {
      let ret = {};
      for (var i in obj) if (obj[i] !== null && obj[i] !== "") ret[i] = obj[i];
      return ret;
    },
    validateForm() {
      let errors = [];

      // Full Name
      if (!this.form.fullname)
        errors.push("<strong>Full Name</strong> is a required field!");

      // Nomor Polisi
      if (!this.form.nopol)
        errors.push("<strong>Nomor Polisi</strong> is a required field!");

      // Ekspedisi
      if (!this.form.ekspedisi)
        errors.push("<strong>Ekspedisi</strong> is a required field!");

      // NEW MODE
      if (this.isNew) {
        // Password
        if (!this.form.password)
          errors.push("<strong>Password</strong> is a required field!");
        // Retype Password
        // else if (!this.retype_password) errors.push('<strong>Retype Password</strong> is a required field!');
        // Password does not match with retype password
        // else if (this.form.password !== this.retype_password) errors.push('<strong>Password</strong> does not match with <strong>Retype Password</strong>!');
      }

      // EDIT MODE
      else {
        // Reset Password Not Empty
        // if (this.form.password || this.retype_password) {
        // Password does not match with retype password
        //     if (this.form.password !== this.retype_password) errors.push('<strong>Password</strong> does not match with <strong>Retype Password</strong>!');
        // }
      }

      if (errors.length > 0) {
        this.$swal.fire({
          title: "Error!",
          icon: "error",
          type: "error",
          html: errors.join("<br>"),
        });
        return false;
      } else return true;
    },
    async submitForm() {
      let vm = this;

      if (await vm.validateForm()) {
        let method = this.isNew ? "post" : "put";
        let url = this.isNew ? this.api_new : this.api_edit;

        let form = JSON.parse(JSON.stringify(this.form));

        this.isLoading = true;

        this.$swal({
          title: 'Loading....'
        })
        this.$swal.showLoading();

        this.$http[method](url, await this.notNullObject(form))
          .then(() => {
            this.isLoading = false;
            this.$swal.close();
            // alert(`Partshop ${vm.form.name} has been created`);
            this.$swal.fire({
              title: "Success!",
              icon: "success",
              text: `${this.form.fullname} has been successfully ${
                this.isNew ? "created" : "edited"
              }`,
            });

            this.$emit("refreshData");
            this.$emit("closeModal");
          })
          .catch((err) => {
            console.log(err);
            if (Array.isArray(err.response.data.data.details)) {
              this.$swal.fire({
                title: "Error!",
                icon: "error",
                type: "error",
                html: err.response.data.data.details
                  .map((x) => x.message)
                  .join("<br>"),
              });
            } else {
              this.$swal.fire({
                title: "Error!",
                icon: "error",
                type: "error",
                text: err.response.data.message,
              });
            }
          });
      }
    },
  },
};
</script>

<style>
/* TRANSPORTER MULTISELECT START */
.transporter-multiselect {
  font-size: 12px;
  margin: 0;

  display: flex;
  flex-direction: row-reverse;
}

.transporter-multiselect > .multiselect__tags {
  border: 0px solid white;
  min-height: 36px;
  padding-top: 10px;

  padding: 8px 9px 8px 0;
}

.transporter-multiselect > .multiselect__tags > .multiselect__single {
  margin: 0;
}

.transporter-multiselect > .multiselect__select {
  height: 36px;
  left: 1px;
  right: 0;
}
.transporter-multiselect {
  min-height: 36px;
  /* box-shadow: 0px 2px 6px #0000001A; */
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  font: normal normal 500 10px/11px Ubuntu;
  color: #343434;
}
.transporter-multiselect .multiselect__placeholder {
  font-weight: bold;
  color: #343434;
  margin: 0;
}
.transporter-multiselect .multiselect__select::before {
  border-color: #343434 transparent transparent;
  top: 50%;
}
.transporter-multiselect:has(.multiselect__placeholder)
  .multiselect__select::before {
  border-color: #343434 transparent transparent;
  top: 65%;
}

.transporter-multiselect .multiselect__input,
.transporter-multiselect .multiselect__element {
  text-align: right;
}

.transporter-multiselect .multiselect__content-wrapper {
  top: 45px;
}
/* TRANSPORTER MULTISELECT END */
</style>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  /* padding: 20px 30px; */
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-default-button {
  float: right;
}

/*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}

/* MODAL ENDS */

/* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding: 20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  /* margin-bottom: 40px; */
  text-align: center;
}

.sub--title {
  color: red;
  margin-bottom: 40px;
  text-align: center;
}

.center {
  text-align: center;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}

.outerBox {
  padding: 0 20px;
}
.innerBox {
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  padding: 5vw;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15);
}
.paddingInnerInnerBox {
  padding: 10px 15px;
}
.outerBoxPass {
  padding: 20px;
}
.innerBoxPass {
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  box-shadow: 10px 10px 20px #e0e0e0;
}
.innerBoxPass > .row:first-child {
  cursor: pointer;
}
.paddingInnerInnerBox p {
  margin: 0;
}
.subPartTitle {
  font-size: 110%;
  padding: 6px 12px;
  color: #757575;
}
.collapsed:hover {
  text-decoration: underline;
}
.collapseButton {
  color: black;
}

.input--style-4:disabled {
  background: #cfcfcf;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: auto;
}

.innerBox {
  padding: 0.8em 1.5em;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  box-shadow: 2px 2px 5px #e0e0e0;
}

.hoverable:hover {
  cursor: pointer;
}

.transporter-input-row-group {
  margin-bottom: 10px;

  transition: margin-bottom 0.3s ease;
}

.transporter-input-row-group > div {
  display: flex;
  align-items: center;
}

.transporter-title {
  font-family: "Poppins";
  font-size: 20px;
  font-weight: medium;

  padding: 20px 25px;
  margin: 0;
}

.transporter-label {
  font-family: "Poppins";
  font-size: 18px;

  margin: 0;
}

.transporter-input {
  border: 1px solid #1b698e;
  border-radius: 8px;
  text-align: center;
  color: #1b698e;

  font-family: "Poppins";
  font-size: 14px;
  line-height: 21px;

  padding: 3px 10px;
  margin: 0;
}

.transporter-button {
  font-family: "Poppins";
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;

  padding: 12px 0;
  width: 100%;

  background: #1b698e;
  color: white;
  border: 1px solid #1b698e;
  border-radius: 8px;
}

.transporter-button-outline {
  font-family: "Poppins";
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;

  padding: 12px 0;
  width: 100%;

  background: white;
  color: #1b698e;
  border: 1px solid #1b698e;
  border-radius: 8px;
}

.modal-close {
  background-color: #f2f2f2;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-top-right-radius: 8px;

  cursor: pointer;
  transition: background-color 0.3s ease;
}

.modal-close:hover {
  background-color: #e0e0e0;
}
</style>
